import { createApiCall } from "services/api/createApiCall";

import { transformExpenseType } from "./transformations";
import { ExpenseType } from "./types";

/*---------------------------------------------------------------------------------------
   GET - COST CATEGORIES
-----------------------------------------------------------------------------------------*/
export const getExpenseTypesAPI = async (
  appliesTo?: string
): Promise<ExpenseType[]> => {
  const response = await createApiCall(
    {
      path: `/v1/finance/lookups/invoice/expense-types${appliesTo ? `?appliesTo=${appliesTo}` : ""}`,
      method: "GET",
    },
    {
      getMessage: {
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return (response.data ?? []).map(transformExpenseType);
};

/*---------------------------------------------------------------------------------------
   CREATE / UPDATE / DELETE - COST CATEGORY
-----------------------------------------------------------------------------------------*/
export const createExpenseTypeAPI = async (
  payload: { name: string; code?: string | null; parentId?: string | null; appliesTo?: string | null; ordinal?: number },
  t: (key: string) => string
): Promise<void> => {
  await createApiCall(
    {
      path: `/v1/finance/lookups/invoice/expense-types`,
      method: "POST",
      body: payload,
    },
    {
      getMessage: {
        success: () => "Vrsta troška je spremljena",
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();
};

export const updateExpenseTypeAPI = async (
  id: string,
  payload: { name: string; code?: string | null; parentId?: string | null; appliesTo?: string | null; ordinal?: number },
  t: (key: string) => string
): Promise<void> => {
  await createApiCall(
    {
      path: `/v1/finance/lookups/invoice/expense-types/${id}`,
      method: "PUT",
      body: payload,
    },
    {
      getMessage: {
        success: () => "Vrsta troška je spremljena",
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();
};

export const deleteExpenseTypeAPI = async (
  id: string,
  t: (key: string) => string
): Promise<void> => {
  await createApiCall(
    {
      path: `/v1/finance/lookups/invoice/expense-types/${id}`,
      method: "DELETE",
    },
    {
      getMessage: {
        success: () => "Vrsta troška je obrisana",
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();
};
